import {createOfflineFileVault} from './offlineFileVault.js';
import {validateOfflineAttachmentCommand, verifyOfflineAttachmentReceipt} from './offlineAttachmentCommand.js';
import {formRevision} from './visitaFormUpdatePolicy.js';

// Solo un journal contractual ya confirmado y todavía referenciado exactamente
// por el contexto autorizado. No reconstruye manifiestos ni fabrica un ACK.
export async function inspectLegacyAcknowledgedFile({file, context, user}) {
    if (file?.state !== 'acknowledged' || file.userId !== Number(user.id) || file.empresaId !== Number(user.empresa_id)
        || file.visitaId !== Number(context.visita.id) || file.originRevision !== formRevision(context)
        || file.legacyVisitReceiptId || !['image', 'document'].includes(file.kind)
        || !context.permissions?.[file.kind === 'document' ? 'can_manage_documentation' : 'can_upload_images'])
        throw Error('El manifiesto o recibo anterior requiere conciliación de identidad, revisión o autorización. Se conserva íntegro.');
    const manifest = await validateOfflineAttachmentCommand(file, file.uploadCommand);
    const receipt = await verifyOfflineAttachmentReceipt(file, file.uploadCommand, file.uploadReceipt);
    const rows = file.kind === 'image' ? context.visita.imagenes : context.visita.adjuntos_documentacion;
    const matches = (rows || []).filter(row => row?.client_uuid === file.id);
    const reference = matches[0];
    if (matches.length !== 1 || reference.file_sha256 !== file.sha256 || Number(reference.size) !== file.size
        || (reference.filename ?? reference.path) !== receipt.data.filename
        || file.kind === 'image' && (reference.instance_ref ?? null) !== manifest.instance_ref
        || file.kind === 'document' && reference.tipo != null && reference.tipo !== manifest.mime_type)
        throw Error('El archivo confirmado no tiene una referencia única y exacta en el contexto vigente. Se conserva para conciliación.');
    return {manifest, receipt};
}

export async function readLegacyAcknowledgedFile({file, driver, fs}) {
    const vault = createOfflineFileVault({driver, fs}), bytes = await vault.verify(file);
    const manifest = await validateOfflineAttachmentCommand(file, file.uploadCommand);
    if (manifest.mime_type !== 'application/pdf') return {file, bytes, mimeType: manifest.mime_type};
    const copy = await vault.prepareReadCopy(file);
    return {file: copy, bytes, mimeType: 'application/pdf'};
}
